import React, { useEffect } from 'react';
import { Newsletter } from '@marty-js/design/src/molecules/newsletter';
import { Reassurance } from '@marty-js/design/src/atoms/reassurance';
import type { ItemSidebarComponentFeatureType } from '../types';
import FeatureAd from './featureAd';
import FeatureProgrammableComponent from './featureProgrammableComponent';

const featureComponent: { [key: string]: React.FC<ItemSidebarComponentFeatureType | null> } = {
  ad_content: FeatureAd,
  reinsurance: Reassurance,
  newsletter: Newsletter,
  programmable_component: FeatureProgrammableComponent,
};

const Feature: React.FC<ItemSidebarComponentFeatureType> = ({ data, template, setIsIamSticky }) => {
  useEffect(() => {
    if (data?.data?.data?.slug === 'ad_content') {
      setIsIamSticky(true);
    } else {
      setIsIamSticky(false);
    }
  }, [data?.data?.data?.slug, setIsIamSticky]);

  if (data?.data?.data?.slug in featureComponent) {
    const Component = featureComponent[data.data.data.slug];

    return <Component data={data} template={template} />;
  }

  return null;
};

export default Feature;
